import React from 'react';
import styles from '../../../styles/DocumentManagement.module.css';
import { DocumentWithType } from '../../../types/Document';

interface RecentProps {
    recentDocuments: DocumentWithType[];
}

const RecentDocuments: React.FC<RecentProps> = ({ recentDocuments }) => {
    return (
        <div className={styles.documentsOverviewRecentList}>
            {recentDocuments.length === 0 ? (
                <div className={styles.documentsOverviewEmpty}>No recent documents found.</div>
            ) : (
                recentDocuments.map(doc => (
                    <div key={doc.id} className={styles.documentsOverviewDocCard}>
                        <div className={styles.documentsOverviewDocHeader}>
                            <span className={styles.documentTitle}>{doc.title}</span>
                            <span className={styles.documentsOverviewDocType}>{doc.typeID?.name || 'Unknown Type'}</span>
                        </div>
                        <div className={styles.documentsOverviewDocMetaRow}>
                            <span className={styles.documentsOverviewDocMeta}><strong>Date:</strong> {doc.createdAt ? new Date(doc.createdAt).toLocaleDateString() : 'N/A'}</span>
                            {(() => {
                                let expired = false;
                                if (doc.expiryDate) {
                                    const expDate = new Date(doc.expiryDate);
                                    expired = expDate < new Date();
                                }
                                return (
                                    <span className={expired ? styles.documentExpired : styles.documentValid}>
                                        {doc.expiryDate ? (expired ? 'Expired' : 'Valid') : 'No Expiry'}
                                    </span>
                                );
                            })()}
                        </div>
                    </div>
                ))
            )}
        </div>
    );
};

export default RecentDocuments;